import { useEffect, useState } from "react";
import styles from "./App.module.css";
import parse_xml from "../../util/parse-xml";
import ExcelExport from "../excel/saveToExcel";
import "../../styles/global.css";

const getData = async (lang) => {
  let url = process.env.REACT_APP_PRODUCT_FEEDS_EN;
  try {
    if (lang === "ar") {
      url = process.env.REACT_APP_PRODUCT_FEEDS_AR;
    }
    return await parse_xml(url);
  } catch (err) {
    console.error(err);
    return [];
  }
};

function App() {
  const [data, setData] = useState([]);
  const [downloadableData, setDownloadableData] = useState([]);
  const [search, setSearch] = useState("");
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const fetchData = async () => {
      const items = await getData(lang);
      setData(items);
    };

    fetchData();
  }, [lang]);

  useEffect(() => {
    if (data.length > 0) {
      const cleanedData = data.map((item) => ({
        id: item["g:id"],
        title: item["g:title"],
        category: item["g:google_product_category"],
        price: item["g:price"],
        sale_price: item["g:sale_price"],
        sku: item["g:mpn"],
        link: item["g:link"],
      }));

      setDownloadableData(cleanedData);
    }
  }, [data]);

  useEffect(() => {
    const fetchAndFilterData = async () => {
      const items = await getData(lang);
      if (search.length === 0) {
        setData(items);
        return;
      }

      const filteredData = items.filter((item) => {
        return (
          item["g:google_product_category"]?.toLowerCase().includes(search.toLowerCase()) ||
          item["g:title"]?.toLowerCase().includes(search.toLowerCase()) ||
          item["g:mpn"]?.toLowerCase().includes(search.toLowerCase()) ||
          item["g:id"]?.toString().toLowerCase().includes(search.toLowerCase())
        );
      });

      setData(filteredData);
    };

    fetchAndFilterData();
  }, [search, lang]);

  const handleSearch = (value) => setSearch(value.trimStart().trimEnd());
  const handleClick = async () => setSearch("");

  return (
    <div className={styles.appWrapper}>
      <div className={styles.appWrapperInner}>
        <div className={styles.appSearchWrapper}>
          <div className={styles.appDropdown}>
            <select name="=lang" id="=lang" value={lang} onChange={(e) => setLang(e.target.value)}>
              <option value="en">EN</option>
              <option value="ar">AR</option>
            </select>
          </div>
          <input value={search} className={styles.appSearch} onChange={(e) => handleSearch(e.target.value)} placeholder="Search..." />
          <button className={styles.appSearchCloseBtn} onClick={handleClick}>
            X
          </button>
        </div>

        <table className={styles.styledTable}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Thumbnail</th>
              <th>Title</th>
              <th>Category</th>
              <th className={styles.price}>Price</th>
              <th>Stock</th>
              <th>
                Rating/
                <br />
                Review
              </th>
              <th>SKU</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item["g:id"]}>
                <td>{item["g:id"]}</td>
                <td>
                  <img src={item["g:image_link"]} alt="Product" />
                </td>
                <td>{item["g:title"]}</td>
                <td>{item["g:google_product_category"]}</td>
                <td>
                  {item["g:sale_price"] ? (
                    <>
                      <span className={styles.striked}>{item["g:price"]}</span>
                      <br />
                      {item["g:sale_price"]}
                    </>
                  ) : (
                    item["g:price"]
                  )}
                </td>
                <td>{item["g:availability"] === "in_stock" ? "Y" : "N"}</td>
                <td>{item["g:product_rating"] && item["g:number_of_reviews"] ? `${item["g:product_rating"]} / ${item["g:number_of_reviews"]}` : "None"}</td>
                <td>{item["g:mpn"]}</td>
                <td>
                  <a href={item["g:link"]} target="_blank" rel="noopener noreferrer">
                    View
                  </a>
                  <button onClick={() => navigator.clipboard.writeText(item["g:link"])}>Copy Link</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {data && data.length === 0 && <div className={styles.appNoData}>No data</div>}
        <ExcelExport data={downloadableData} fileName={`sharafdg_esis_products_${new Date().toISOString().split("T")[0]}`} />
      </div>
    </div>
  );
}

export default App;
